import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendIntegrationAsset,
  BackendMutationIntegrationAssetsPerformActionArgs,
} from 'src/types/backend';

import { INTEGRATION_ASSET } from './schema';

const MUTATION = gql`
  mutation IntegrationAssetsPerformAction(
    $customerId: ID!
    $workspaceId: ID
    $integrationAssetId: ID
    $accountId: ID
    $dataSource: IntegrationDataSourceEnum!
    $actionsList: [IntegrationActionTypeEnum!]!
    $customModelBrandVoiceId: ID
  ) {
    integrationAssetsPerformAction(
      customerId: $customerId
      workspaceId: $workspaceId
      integrationAssetId: $integrationAssetId
      accountId: $accountId
      dataSource: $dataSource
      actionsList: $actionsList
      customModelBrandVoiceId: $customModelBrandVoiceId
    ) {
      ...IntegrationAsset
    }
  }
  ${INTEGRATION_ASSET}
`;

type Variables = BackendMutationIntegrationAssetsPerformActionArgs;
type Result = BackendIntegrationAsset;

export const integrationAssetsPerformAction = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
